export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 获取批量用户标签
    getUsersTagList: function getUsersTagList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/event/user/log/batch",
        method: "get",
        params: data
      });
    },
    // 获取单个用户标签
    getUserTagList: function getUserTagList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/event/user/log",
        method: "get",
        params: data
      });
    }
  };
});